export default (value, first = true) => {
  if (first) {
    return this[0].toUpperCase() + this.substring(1)
  }

  var builder = ''

  for (var i = 0, length = this.length; i < length; i++) {
    var c = this[i - 1]
    if (!c || (c === ' ' || c === '\t' || c === '\n')) {
      c = this[i].toUpperCase()
    } else {
      c = this[i]
    }
    builder += c
  }

  return builder
}



// WEBPACK FOOTER //
// ./src/filters/capitalize.js